/*
 * Adds a "Search" entry at the top of the mobile hamburger drawer menu.
 *
 * The theme already has a full-featured search modal (predictive search +
 * popular searches) wired up in sections/header.liquid via <details-modal
 * class="header__search ...">. Rather than duplicating that markup inside
 * the drawer, this injects a lightweight button that closes the drawer and
 * opens the existing modal, reusing all of its behavior.
 */
(function () {
	function initMenuDrawerSearch() {
		var menuDrawer = document.getElementById('menu-drawer');
		if (!menuDrawer) return;
		if (menuDrawer.querySelector('#MenuDrawer-SearchButton')) return;

		// Insert *inside* <nav class="menu-drawer__navigation">, not as a sibling
		// before it. The parent (.menu-drawer__navigation-container) is a CSS
		// grid with exactly two row tracks (`1fr auto`) sized for [nav, utility
		// links]; adding a sibling in front of <nav> shifts nav into the second
		// track and hands our small button the flexible 1fr track meant for
		// nav's scroll area, which is what pushed it up into the header and
		// squeezed everything else. Living inside <nav> avoids touching that
		// grid at all.
		var nav = menuDrawer.querySelector('.menu-drawer__navigation');
		if (!nav) return;
		var menuList = nav.querySelector('.menu-drawer__menu');

		var wrapper = document.createElement('div');
		wrapper.className = 'menu-drawer__search';
		wrapper.style.borderBottom = '0.1rem solid rgba(var(--color-foreground-secondary), 0.75)';

		wrapper.innerHTML =
			'<button type="button" id="MenuDrawer-SearchButton" class="link link--text focus-inset" ' +
			'style="display:flex;align-items:center;gap:1rem;width:100%;background:none;border:none;padding:1.8rem 0;cursor:pointer;font:inherit;font-size:1.2rem;color:currentColor;">' +
			'<svg class="icon icon-search" aria-hidden="true" focusable="false" role="presentation" style="width:1.8rem;height:1.8rem;flex-shrink:0;">' +
			'<use href="#icon-search"></use>' +
			'</svg>' +
			'<span>Search</span>' +
			'</button>';

		if (menuList) {
			nav.insertBefore(wrapper, menuList);
		} else {
			nav.insertBefore(wrapper, nav.firstChild);
		}

		var menuSearchBtn = wrapper.querySelector('#MenuDrawer-SearchButton');
		menuSearchBtn.addEventListener('click', function () {
			var headerDrawerEl = menuSearchBtn.closest('header-drawer');
			var mainDetails = headerDrawerEl && headerDrawerEl.querySelector(':scope > details');
			if (
				headerDrawerEl &&
				mainDetails &&
				mainDetails.hasAttribute('open') &&
				typeof headerDrawerEl.closeMenuDrawer === 'function'
			) {
				headerDrawerEl.closeMenuDrawer(mainDetails.querySelector('summary'));
			}

			var headerSearchEl = document.querySelector('.header__search.no-js-hidden');
			var searchToggle = headerSearchEl && headerSearchEl.querySelector('summary');
			if (headerSearchEl && searchToggle) {
				window.setTimeout(function () {
					// The theme hides the header search modal entirely on narrow
					// (portrait) viewports via `.header .header__search { display:
					// none !important; }` whenever the "mobile header icon" setting
					// is "calendar" (the current default). That CSS rule hides the
					// whole modal outright regardless of whether its <details> is
					// open, which is why tapping this button previously appeared to
					// do nothing on an iPhone in portrait mode: the modal *did* open
					// internally, it was just invisible.
					//
					// Force it visible for as long as it's open, and take it out of
					// the header's grid flow (position:fixed, 0x0) so it can't affect
					// header layout or flash a duplicate icon. The modal panel itself
					// is already positioned to overlay the page, so this wrapper's
					// own box size doesn't matter.
					headerSearchEl.style.setProperty('display', 'block', 'important');
					headerSearchEl.style.setProperty('position', 'fixed', 'important');
					headerSearchEl.style.setProperty('top', '0', 'important');
					headerSearchEl.style.setProperty('left', '0', 'important');
					headerSearchEl.style.setProperty('width', '0', 'important');
					headerSearchEl.style.setProperty('height', '0', 'important');
					headerSearchEl.style.setProperty('overflow', 'visible', 'important');
					searchToggle.style.setProperty('display', 'none', 'important');

					searchToggle.click();

					var detailsEl = headerSearchEl.querySelector('details');
					if (detailsEl && window.MutationObserver) {
						var observer = new MutationObserver(function () {
							if (!detailsEl.hasAttribute('open')) {
								headerSearchEl.style.removeProperty('display');
								headerSearchEl.style.removeProperty('position');
								headerSearchEl.style.removeProperty('top');
								headerSearchEl.style.removeProperty('left');
								headerSearchEl.style.removeProperty('width');
								headerSearchEl.style.removeProperty('height');
								headerSearchEl.style.removeProperty('overflow');
								searchToggle.style.removeProperty('display');
								observer.disconnect();
							}
						});
						observer.observe(detailsEl, { attributes: true, attributeFilter: ['open'] });
					}
				}, 100);
			}
		});
	}

	document.addEventListener('DOMContentLoaded', initMenuDrawerSearch);
	document.addEventListener('shopify:section:load', initMenuDrawerSearch);
})();
